import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/styles.scss';export default {
  "main": "_main_ok1e7_1",
  "resource": "_resource_ok1e7_7",
  "iconBox": "_iconBox_ok1e7_18",
  "icon": "_icon_ok1e7_18",
  "openedIcon": "_openedIcon_ok1e7_34",
  "row": "_row_ok1e7_38",
  "avatar": "_avatar_ok1e7_47",
  "col": "_col_ok1e7_54",
  "name": "_name_ok1e7_64",
  "profession": "_profession_ok1e7_69",
  "recordList": "_recordList_ok1e7_74"
};